import React, { useState } from 'react'
import {
  FormControlLabel,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  TextField,
  Paper,
  FormGroup,
  Checkbox,
} from "@material-ui/core";
import { AutorizacionesBuscador } from '../../autorizaciones/Ingreso/AutorizacionesBuscador';

export const ModalAfiliadoLiq = ({open, onCloseModal, setAfiliado, lineaExistente,
  esCodigoLiquidacion, setAfiliadoInexistente, showAfiInexistente = false}) => {
  const [afiliadoTemp, setAfiliadoTemp] = useState();
  const [afiInexistente, setAfiInexistente] = useState();
  const [enableCheckAfiInexistente, setEnableCheckAfiInexistente] = useState(lineaExistente ? true : false);

  const handleSelectAfiliado = () => {    
    setAfiliado(
      {
        idAfiliado: afiliadoTemp?.id_afiliado,
        carnet: afiliadoTemp?.carnet,
        apellidoNombre: afiliadoTemp?.apellido_y_nombre
      }
    );
    if(afiliadoTemp)
      setAfiliadoInexistente();
    else if(showAfiInexistente)
      setAfiliadoInexistente(afiInexistente);
    handleCloseModal();  
  }

  const handleCloseModal = () => {
    onCloseModal();
    setAfiliadoTemp();
  }

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={handleCloseModal}
    >
      <DialogTitle>Seleccionar Afiliado</DialogTitle>
      <DialogContent style={{minHeight: 125, overflowY: 'initial'}}>
        <AutorizacionesBuscador
          hideTitle={true}
          liquidaciones={true}
          setAfiliadoTemp={setAfiliadoTemp}
          setAfiInexistente={setAfiInexistente}
          disabled={(enableCheckAfiInexistente || lineaExistente) && !esCodigoLiquidacion}
          setEnableCheckAfiInexistente={setEnableCheckAfiInexistente}
        />
        {showAfiInexistente && !afiliadoTemp &&
          <Grid container spacing={1}>
            <Grid item sm={4}>
              <Paper style={{marginTop: -5, boxShadow: 'none'}}>
                <FormGroup row>
                  <FormControlLabel
                      control={
                      <Checkbox
                          name="enableCheckAfiInexistente"
                          checked={enableCheckAfiInexistente}
                          disabled={afiliadoTemp || lineaExistente}
                          onChange={(e) => {
                            setEnableCheckAfiInexistente(e.target.checked);
                            setAfiliadoTemp();
                            if(!e.target.checked)
                              setAfiInexistente();                            
                          }}
                      />
                      }
                      label="Inexistente"
                  />
                </FormGroup>
              </Paper>
            </Grid>
            {enableCheckAfiInexistente &&
              <Grid item sm={8} style={{marginTop: -10}}>
                <TextField
                  label="Afiliado Inexistente"
                  margin="normal"
                  name="afiInexistente"
                  value={afiInexistente ?? ''}
                  autoComplete="off"
                  onChange={(e) => {setAfiInexistente(e.target.value)}}            
                  fullWidth
                />
              </Grid>
            }
          </Grid>
        }
      </DialogContent>
      <DialogActions>
        <Grid item container justify="center" style={{marginBottom: 10, marginTop: showAfiInexistente && 25}}>
          <Button 
            onClick={handleCloseModal}
            variant="contained" 
            color="primary"
          >
            Cancelar
          </Button>
          <Button
            style={{ marginLeft: 350 }}
            onClick={handleSelectAfiliado} 
            variant="contained"
            color="primary"
          >
            Aceptar
          </Button>
        </Grid>
      </DialogActions>      
    </Dialog>
  )
}
